import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ServiciosService } from '../../services/servicios.service';
import { EquiposComponent } from 'app/components/servicio-medico/despacho/subdespacho/equipos/equipos.component';

@Component({
  selector: 'app-estado-turnos',
  templateUrl: './estado-turnos.component.html',
  styleUrls: ['./estado-turnos.component.scss']
})
export class EstadoTurnosComponent implements OnInit {
  public datos;
  public datosUsuario = JSON.parse(localStorage.getItem('usuario'));

  constructor(@Inject(MAT_DIALOG_DATA) private data,
              private dialog: MatDialog,
              private servicio:ServiciosService,
              public dialogRef: MatDialogRef<EquiposComponent>) { }

  ngOnInit() {
        console.log(this.data.datos.VEHCOD);
  }

  cerrarturno(){
      this.servicio.cerrarTurno(this.data.datos.VEHCOD).subscribe((data)=>{
        console.log(data);
      })
      this.dialogRef.close('cerrarTurno')
  }

  aperturaTurno(){
      this.servicio.obtenerInfoEquipo(this.data.datos.VEHCOD).subscribe((data)=>{
        this.datos = data;
        this.datos[0].usuario = this.datosUsuario.id_usuario;
        this.servicio.AperturaTurno(this.datos).subscribe((data)=>{
            console.log(data);
        })
      });

      this.servicio.aperturaMovil(this.data.datos.VEHCOD).subscribe((data)=>{
          console.log(data);
      })
  }

}
